export * from "./complimentary-banner.component";
